<template>
  <v-layout row :class="{'bold-text': open}">
    <v-flex xs7 pr-2 class="prevent-overflow">
      {{assessment.module}}
    </v-flex>
    <v-flex xs3 class="hidden-xs-only">
      {{assessment.lastUpdated | date}}
    </v-flex>
    <v-flex xs2 class="text-left">
      {{assessment.grade}}
    </v-flex>
  </v-layout>
</template>

<script>
  import Colors from '../../mixins/Colors'
  import DateFormat from '../../mixins/DateFormat'

  export default {
    name: 'student-assessments-header',
    props: ['assessment', 'open'],
    mixins: [Colors, DateFormat],
    data () {
      return {
        timeUp: false
      }
    },
    mounted () {
      this.$el.parentElement.parentElement.style.transition = 'all 0.3s ease-in'
      this.changeColors()
      setTimeout(() => {
        this.timeUp = true
      }, 1000)
    },
    methods: {
      changeColors () {
        const bgColor = this.lightenColor(this.$vuetify.theme.primary, 2)
        const textColor = this.getTextColor(bgColor)
        this.$el.parentElement.parentElement.style.backgroundColor = this.open ? bgColor : ''
        this.$el.parentElement.parentElement.style.color = this.open ? textColor : ''
        this.iconStyle = this.open ? {color: textColor} : ''
      }
    },
    computed: {},
    watch: {
      open (value) {
        this.changeColors()
        if (!this.timeUp) {
          setTimeout(() => {
            this.$el.scrollIntoView({behavior: 'smooth', block: 'center'})
          }, 400)
        }
      },
      backgroundColor (value) {
        console.log(value)
      }
    }
  }
</script>

<style scoped>
  .bold-text {
    font-weight: 900;
  }

  .align-self-center {
    align-self: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/StudentAssessmentsHeader.vue